import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function useConsentData(dateFilter = "12months") {
    let backend_url = `${process.env.REACT_APP_BACKEND_URL}/consent-data?_limit=-1`;
    
    // Add date filter parameter if not "all"
    if (dateFilter !== "all") {
        const now = new Date();
        let cutoffDate;
        
        switch (dateFilter) {
            case "12months":
                cutoffDate = new Date(now.getFullYear(), now.getMonth() - 12, now.getDate());
                break;
            case "2years":
                cutoffDate = new Date(now.getFullYear() - 2, now.getMonth(), now.getDate());
                break;
            default:
                cutoffDate = new Date(now.getFullYear(), now.getMonth() - 12, now.getDate());
        }
        
        const cutoffDateStr = cutoffDate.toISOString();
        backend_url += `&consent_date_gte=${cutoffDateStr}`;
    }
    
    const { authState, setAuthState } = useContext(AuthContext);
    const [res, setRes] = useState({
        data: null,
        complete: false,
        loading: false,
        error: false,
    });

    const [resetCount, setResetCount] = useState(0);

    const reset = () => {
        var newResetCount = resetCount + 1;
        setResetCount(newResetCount);
    };

    useEffect(() => {
        setRes({
            data: null,
            loading: true,
            error: false,
            complete: false,
        });
        axios({
            url: backend_url,
            method: "GET",
            headers: {
                Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
            },
        })
            .then((res) =>
                setRes({
                    data: res.data,
                    loading: false,
                    error: false,
                    complete: true,
                })
            )
            .catch((e) =>
                setRes({
                    data: null,
                    loading: false,
                    error: true,
                    errorMessage: e.response,
                    complete: true,
                })
            );
    }, [resetCount, dateFilter]);

    return [res, reset];
}
